<template>
    <div id="centroNuevo">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <h4 class="grey--text text--darken-1">
              <v-icon small color="primary">drag_indicator</v-icon> Nuevo Curso Ofertado
            </h4>
          </v-flex>
        </v-layout>
        <v-card>
          <v-card-title class="headline lighten-3">
            <v-spacer></v-spacer>
            <v-btn color="primary" dark to="/academico/cursoacademico">Volver</v-btn>
          </v-card-title>

          <v-card-text>
            <v-form ref="form_curso">
              <v-layout row wrap>
                <v-flex xs12 class="my-0 py-0">
                  <v-card-title class="grey lighten-4 py-1 px-1">
                    <h3 class="grey--text text--darken-1">Datos del Curso</h3>
                  </v-card-title>
                  <v-divider class="mb-0"></v-divider>
                </v-flex>

                <v-flex xs5 lg5 class="py-0">
                <v-select 
                  :items="sedesubsede" 
                  label="Sede/Subsede" 
                  item-text="institucioneducativa" 
                  item-value="id" 
                  @change="getcursosAutorizados(sedesub)"
                  v-model="sedesub"
                  :rules="[v => !!v || 'Seleccione una opción']"></v-select>
              </v-flex>

                <v-flex xs6 md6 lg6 class="py-0">
                  <v-select
                    :items="cursos"
                    label="Cursos autorizados vigentes"
                    item-text="curso"
                    item-value="id"
                    v-model="curso.curso_capacitacion"
                    :rules="[v => !!v || 'Seleccione una opción']"
                    required
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 class="py-0">
                  <v-menu
                    v-model="fechaInicio"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="curso.fecha_inicio"
                        label="Fecha de Inicio"
                        append-icon="event"
                        :rules="[v => !!v || 'El campo es requerido']"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="curso.fecha_inicio" @input="fechaInicio = false"  :min = "minimo"></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm6 class="py-0">
                  <v-menu
                    v-model="fechaFin"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="curso.fecha_fin"
                        label="Fecha de Finalización"
                        append-icon="event"
                        :rules="[v => !!v || 'El campo es requerido']"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker :min = "minimo" v-model="curso.fecha_fin" @input="fechaFin = false" ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 class="my-0 py-0">
                  <v-card-title class="grey lighten-4 py-1 px-1">
                    <h4 class="grey--text text--darken-1">Seleccione los días en que se dictará el curso (por defecto es de lunes a viernes, ajuste de acuerdo al curso ofertado)</h4>
                  </v-card-title>
                  <v-divider class="mb-0"></v-divider>
                </v-flex>

                <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                  <v-checkbox
                    v-model="curso.lunes"
                    :label = "'Lunes'"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                  <v-checkbox
                    v-model="curso.martes"
                    :label = "'Martes'"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                  <v-checkbox
                    v-model="curso.miercoles"
                    :label = "'Miércoles'"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                  <v-checkbox
                    v-model="curso.jueves"
                    :label = "'Jueves'"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                  <v-checkbox
                    v-model="curso.viernes"
                    :label = "'Viernes'"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                  <v-checkbox
                    v-model="curso.sabado"
                    :label = "'Sábado'"
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 class="my-0 py-0">
                  <v-card-title class="grey lighten-4 py-1 px-1">
                    <h4 class="grey--text text--darken-1">Por ejemplo: 10:00-10:59, 12:30-13:29, etc. Verifique bien los horarios a registrar para evitar choque de horarios de los facilitadores.</h4>
                  </v-card-title>
                  <v-divider class="mb-0"></v-divider>
                </v-flex>

                <v-flex xs12 sm6 lg6 class="py-0">
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="curso.time1"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="curso.time1"
                            label="Hora de inicio"
                            prepend-icon="schedule"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[v => !!v || 'El campo es requerido']"
                            
                        ></v-text-field>
                        </template>
                        <v-time-picker
                        v-if="menu1"
                        v-model="curso.time1"
                        full-width
                        format="24hr"
                        @click:minute="$refs.menu1.save(curso.time1)"
                        :allowed-minutes="allowedStep"
                        ></v-time-picker>
                    </v-menu>
                </v-flex>

                <v-flex xs12 sm6 lg6 class="py-0">
                    <v-menu
                        ref="menu"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="curso.time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="curso.time"
                            label="Hora de finalización"
                            prepend-icon="schedule"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[v => !!v || 'El campo es requerido']"
                            @blur="calculacarga()"
                        ></v-text-field>
                        </template>
                        <v-time-picker
                        v-if="menu2"
                        v-model="curso.time"
                        full-width
                        format="24hr"
                        @click:minute="$refs.menu.save(curso.time)"
                        :allowed-minutes="allowedStep"
                        ></v-time-picker>
                    </v-menu>
                </v-flex>

                <v-flex xs12 sm4 class="pt-0 pb-1">
                  <v-text-field
                    type="number"
                    label="Tiempo de duración (semanas)"
                    v-model="curso.duracion"
                    :rules="[v => !!v || 'El campo es requerido']"
                    @blur="calculacarga()"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 class="pt-0 pb-1">
                  <v-text-field
                    type="text"
                    label="Carga horaria"
                    v-model="curso.carga_horaria"
                    :rules="[v => !!v || 'El campo es requerido']"
                    readonly 
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 class="pt-0 pb-1">
                  <v-text-field
                    type="number"
                    label="Cupo máximo de participantes"
                    v-model="curso.cupo"
                    :rules="[v => !!v || 'El campo es requerido']"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 class="my-0 py-0">
                  <v-card-title class="grey lighten-4 py-1 px-1">
                    <h4 class="grey--text text--darken-1">Asignación de facilitador al curso</h4>
                  </v-card-title>
                  <v-divider class="mb-0"></v-divider>
                </v-flex>

                <v-flex xs12 md12 lg12 class="py-0">
                  <v-select
                    :items="facilitadores"
                    label="Docentes registrados"
                    item-text="nombre"
                    item-value="id"
                    v-model="curso.facilitador"
                   
                    :rules="[v => !!v || 'Seleccione una opción']"
                    required
                  ></v-select>
                </v-flex>
                
              </v-layout>
              
            </v-form>
            <div class="text-xs-center mt-3">
              <v-btn color="primary" dark @click="confirmCursoA">Guardar</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
      
      
      <v-dialog v-model="mconfirm" width="300">
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>
            <span class="headline">Alerta</span>
          </v-card-title>
          <v-card-text class="text-xs-center">
            {{ mensaje }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loadingBtnSend" v-if="hide_accept" color="success darken-1" flat @click="createCursoAut">
              Aceptar
            </v-btn>
            <v-btn color="blue darken-1" flat @click="mconfirm = false">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="2500"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
      </v-snackbar>
    </div>
  </template>
  <script>
  /* eslint-disable no-console */
  import Service from "../services/general";
  import axios from "axios";
  export default {
    name: "centro-nuevo",
    
    data() {
      return {
        min: '',
        mini: '',  
        minimo: '',
        menu2: false,
        menu1: false,
        fechaFin: false,
        fechaInicio: false,
        sedesubsede: [],
        sedesub: '',
       
        loading: false,
        color_txt: '',
        hide_accept: true,
        loadingBtnSend: false,
        cursos: [],  
        facilitadores: [],  

        centro: {  
          institucional: {
            sede_central: true,
            nombre: '',
            sigla: '',
            departamento_id: '',
            departamento_nombre: '',
            provincia_id: '',
            provincia_nombre: '',
            municipio_id: '',
            comunidad_id: '',
            direccion: '',
            zona: '',
            calle: '',
            telefono: '',
            correo: '',
            geolocalizacion: ''
          },
        },  

        curso: {
        curso_capacitacion: '',
        carga_horaria: '',
        duracion: '',
        time: '',
        time1: '',
        fecha_inicio: '',
        fecha_fin: '',
        cupo: '',
        lunes: true,
        martes: true,
        miercoles: true,
        jueves: true,
        viernes: true,
        sabado: false,
        facilitador: '',
        ie_id: ''
        },   

        mconfirm: false,
        size_width: 0,
        mensaje: '',
        dparams: {},
        snack: {
          state: false,
          color: 'success',
          mode: '',
          text: ''
        }
      };
    },
    mounted() {
      this.dparams = Service.getParams();
      if (this.dparams && this.dparams.roluser != Service.rol().director) {
        this.$router.push({name: 'principal'});
      }
            
      //this.getcursosAutorizados();
      this.poneLimite();
      this.getSedeSub();
      
      this.$nextTick(() => {
        window.addEventListener("resize", this.getWidth);
        this.getWidth();
      });
    },
    methods: {

      allowedStep: m => m == 45 || m == 15 || m == 0 || m == 30,

      getSedeSub(yoyo) { //console.log(yoyo);
          Service.sedeSub(this.dparams.ie_id).then(response => {
            this.sedesubsede = response.data; 
          }).catch(error => {
            console.error('Error al cargar datos', error);
          });
      },

      //allowedDates: val => parseInt(val.split('-')[2], 10) % 2 === 0,

      poneLimite(){
        this.mini = new Date().toLocaleDateString(); 
        this.mini = this.mini.split('/');

        for(let c=this.mini.length-1;c>=0;c--){
          if(this.mini[c] < 10){
            this.mini[c] = '0' + this.mini[c];
          }
          this.minimo = this.minimo + this.mini[c] + '-';
        }

        this.minimo = this.minimo.substring(0, this.minimo.length - 1); 
      },
      
      getWidth() {
        this.size_width = document.documentElement.clientWidth;
      },
      
      getcursosAutorizados(codsedesub) { 
        Service.cursosAutorizados(codsedesub).then(response => {
          this.cursos = response.data.cursos; 
          this.facilitadores = response.data.facilitadores; 
        }).catch(error => {
          console.error('Error al cargar datos', error);
        });
      },
      
      confirmCursoA() { 
        if (this.$refs.form_curso.validate()) {
          this.color_txt = 'grey';
          this.loadingBtnSend = false;
          this.hide_accept = true;
          this.mensaje = '¿Está seguro(a) de registrar el curso ofertado con la información ingresada?';
          this.mconfirm = true;
        } else {
          this.toast('warning', 'Debe completar los datos del formulario.');
        }
      },
      createCursoAut() { 
        this.dparams = Service.getParams();
        this.curso.ie_id = this.sedesub; //console.log(this.curso);
        
        //controlo los minutos para que una hora sean 60 minutos ej. 12:00 a 12:59, 12:15 a 13:14, 12:30 a 13:29 y 12:45 a 13:44
        let horaux = (this.curso.time).split(":");

        if(horaux[1] == '00'){
          horaux[1] = '59';
          horaux[0] = parseInt(horaux[0]) - 1;
        } 
        if(horaux[1] == '30'){
          horaux[1] = '29';
        } 
        if(horaux[1] == '45'){
          horaux[1] = '44';
        } 
        if(horaux[1] == '15'){
          horaux[1] = '14';
        } 
        this.curso.time = horaux[0] +':'+ horaux[1];


        this.loadingBtnSend = true; 
        axios
          .post(Service.getBase() + "guarda/cursoautorizado", this.curso,  Service.getHeader())
          .then(response => {
            this.loadingBtnSend = false;
            if (response.data.estado == 200) {
              this.$refs.form_curso.reset();
              this.mconfirm = false;
              //this.curso = [];
              this.toast("success", "Registro guardado.");
            } else {
              this.toast("warning", response.data.msg);
            }
          })
          .catch(error => {
            this.loadingBtnSend = false;
            this.color_txt = 'error';
            this.hide_accept = true;
            this.mensaje = "No se pudo registrar." + error;
            // this.toast("error", "No se pudo guardar");
          });
      },
      confirmEliminado(facilitador_id) {
        this.facilitador.id = facilitador_id;
        this.mconfirm = true;
      },
      
      toast(color, text) {
        this.snack.color = color;
        this.snack.text = text;
        this.snack.state = true;
      },
      beforeDestroy() {
        window.removeEventListener("resize", this.getWidth);
      },
    
    calculacarga(){
      let hora1 = (this.curso.time).split(":"); //hora finalizacion
      let hora2 = (this.curso.time1).split(":");  //hora inicio
      let t1 = new Date();
      let t2 = new Date();

      t1.setHours(hora1[0], hora1[1],'00');
      t2.setHours(hora2[0], hora2[1],'00');
      //console.log(t1)
      //Aquí hago la resta
      t1.setHours(t1.getHours() - t2.getHours(), t1.getMinutes() - t2.getMinutes(), t1.getSeconds() - t2.getSeconds());

      //dias por semana en que se dictará el curso
      let diaux = 0;
        if(this.curso.lunes == true){
          diaux++;
        }
        if(this.curso.martes == true){
          diaux++;
        }
        if(this.curso.miercoles == true){
          diaux++;
        }
        if(this.curso.jueves == true){
          diaux++;
        }
        if(this.curso.viernes == true){
          diaux++;
        }
        if(this.curso.sabado == true){
          diaux++;
        }
      
      this.curso.carga_horaria = t1.getHours() * diaux * this.curso.duracion;
        //console.log(this.curso.time);
 
    }
    }
  };
  </script>